import React, { Component, } from 'react';
import styled from 'styled-components';
import { BrowserRouter, Switch, Route, } from 'react-router-dom';
import { connect, } from 'react-redux';
import { bool, string, } from 'prop-types';
import Header from '../legacy-tv-ui/Header';

import SideNav from '../components/global/SideNav';
import logo from '../assets/header-logo.png';
import './index.css';
import Prediction from '../scenes/Prediction';
import Performance from '../scenes/Performance';
import Adjustment from '../scenes/Adjustment';
import SymbolSummary from '../scenes/SymbolSummary';
import Login from '../scenes/Login';
import Home from '../scenes/Home';
import DateSelect from '../scenes/DateSelect';

import PageLoading from '../components/PageLoading';
import ErrorToast from '../components/ErrorToast';
import Footer from '../components/global/Footer';
import PrivateRoute from './PrivateRoute';

const MainContainer = styled.div`
  padding-top: 50px;
  background-color: #f5f5f5;
  min-height: calc(100vh - 50px);
  display: flex;
  min-width: 1150px;
  overflow: hidden
`;
const ContentContainer = styled.div`
  position: relative;
  min-height: calc(100vh - 50px);
  position: relative;
  padding-bottom: 50px;
  box-sizing: border-box;
  max-width: 1200px;
  margin: 0 auto;
  flex: 1;
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    max-width: none;
  }
`;

export class Router extends Component {
  static propTypes = {
    isAuth: bool.isRequired,
    errMsg: string.isRequired,
    loading: bool.isRequired,
  }
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { errMsg, loading, isAuth, } = this.props;
    return (
      <BrowserRouter>
        <MainContainer>
          <Header logo={logo} />
          <Route
            path="/:projectId/:year/:month"
            component={SideNav}
          />

          <ContentContainer>
            {
              errMsg
                ? <ErrorToast
                  msg={errMsg}
                />
                : null
            }
            {
              loading &&
              <PageLoading />
            }
            <Switch>
              <Route
                path="/"
                component={props => <Home {...props} isAuth={isAuth} />}
                exact
              />
              <Route
                path="/:projectId"
                component={props => <Login {...props} isAuth={isAuth} />}
                exact
              />
              <Route
                path="/:projectId/login"
                component={props => <Login {...props} isAuth={isAuth} />}
              />
              <PrivateRoute
                path="/:projectId/date-select"
                component={DateSelect}
                isAuth={isAuth}
                exact
              />
              <PrivateRoute
                path="/:projectId/:year/:month/prediction"
                component={Prediction}
                isAuth={isAuth}
              />
              <PrivateRoute
                path="/:projectId/:year/:month/adjustment"
                component={Adjustment}
                isAuth={isAuth}
              />
              <PrivateRoute
                path="/:projectId/:year/:month/performance"
                component={Performance}
                isAuth={isAuth}
              />
              <PrivateRoute
                path="/:projectId/:year/:month/symbol-summary"
                component={SymbolSummary}
                isAuth={isAuth}
              />
            </Switch>
            <Footer />
          </ContentContainer>
        </MainContainer>
      </BrowserRouter>
    );
  }
}

function mapStateToProps(state) {
  return {
    isAuth: state.appState.isAuth,
    errMsg: state.appState.errMsg,
    loading: state.appState.loading,
  };
}

export default connect(mapStateToProps)(Router);



// WEBPACK FOOTER //
// ./src/router/index.js